import { TYPES } from "./setting_withdraw.type";

const initState = {
  settingWithdrawAll: null,
};

const settingWithdrawReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_SETTING_WITHDRAW_ALL:
      return {
        ...state,
        settingWithdrawAll: payload,
      };

    default:
      return state;
  }
};

export default settingWithdrawReducer;
